import * as Types from '../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ListPoolsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListPoolsQuery = { __typename?: 'Query', pools: Array<{ __typename?: 'Pool', id: string, name: string, selfAssessment: boolean, supervisors: Array<string> }> };

export const ListPoolsDocument = gql`
    query ListPools {
  pools {
    id
    name
    selfAssessment
    supervisors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListPoolsGQL extends Apollo.Query<ListPoolsQuery, ListPoolsQueryVariables> {
    document = ListPoolsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }